import React from "react"

import {
	Box,
	Grid
} from "@mui/material"

import {
	t,
	Trans
} from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"

import {
	MatesSelect, MatesTextField,
	withUseFormHook
} from "@sinossi/mates-react-library"

import { AdvancedSearchbar } from "components/advanced-searchbar/advanced-searchbar"

import {
	AssetFilter,
	AssetType,
	ContractType,
	PositionType,
	SwitchEnum, SwitchUtils,
} from "models"

import AssetAdvancedSearchValidation, { AssetAdvancedSearchForm } from "./form"

interface AssetAdvancedSearchProps extends UseFormReturn {
	handleCallback: (data: AssetFilter) => void
	isInLandlordDashboard?: boolean;
}

interface AssetAdvancedSearchState {
	loading: boolean
}
class AssetAdvancedSearch extends React.Component<AssetAdvancedSearchProps, AssetAdvancedSearchState> {

	constructor(props: AssetAdvancedSearchProps) {
		super(props);
		this.state = {
			loading: true
		}
	}


	componentDidMount() {
		this.initializeForm()

		this.setState(() => ({
			loading: false
		}))
	}

	private initializeForm = () => {
		const storageRequest: AssetFilter = localStorage.getItem("assetResearch") ? JSON.parse(localStorage.getItem("assetResearch")!) : null

		if (storageRequest && !this.props.isInLandlordDashboard) {
			this.props.setValue("city", storageRequest.city)
			this.props.setValue("province", storageRequest.province)
			this.props.setValue("region", storageRequest.region)
			this.props.setValue("position", storageRequest.positionType)
			this.props.setValue("assetType", storageRequest.type)
			this.props.setValue("shopWindows", storageRequest.shopWindows)
			this.props.setValue("contractType", storageRequest.contractType)
			this.props.setValue("glaMin", storageRequest.glaMin)
			this.props.setValue("glaMax", storageRequest.glaMax)
			this.props.setValue("minPrice", storageRequest.priceMin)
			this.props.setValue("maxPrice", storageRequest.priceMax)
			this.props.setValue("divisible", SwitchUtils.setSelectValue(storageRequest.divisible !== undefined ? storageRequest.divisible : null))
			this.props.setValue("parkingSlots", SwitchUtils.setSelectValue(storageRequest.parkingSlots !== undefined ? storageRequest.parkingSlots : null))
			this.props.setValue("airConditioning", SwitchUtils.setSelectValue(storageRequest.airConditioning !== undefined ? storageRequest.airConditioning : null))
		}
		else {
			this.props.setValue("city", "")
			this.props.setValue("province", "")
			this.props.setValue("region", "")
			this.props.setValue("position", "")
			this.props.setValue("assetType", "")
			this.props.setValue("shopWindows", "")
			this.props.setValue("contractType", "")
			this.props.setValue("glaMin", "")
			this.props.setValue("glaMax", "")
			this.props.setValue("minPrice", "")
			this.props.setValue("maxPrice", "")
			this.props.setValue("divisible", SwitchEnum.UNINTERESTING)
			this.props.setValue("parkingSlots", SwitchEnum.UNINTERESTING)
			this.props.setValue("airConditioning", SwitchEnum.UNINTERESTING)
		}
	}

	private onSearch = (data: Record<string, any>): void => {
		const formData: AssetAdvancedSearchForm = new AssetAdvancedSearchForm()
		Object.assign(formData, data)

		const request: AssetFilter = formData.toRequest()
		this.props.handleCallback(request)
		//localStorage.setItem("assetResearch", JSON.stringify(request))
	}

	render() {
		return (
			<Box>
				{
					!this.state.loading &&
					<AdvancedSearchbar
						{...this.props}
						searchFieldName="address"
						searchFieldPlaceholder="Ricerca per indirizzo"
						onSearch={this.onSearch}
						clearFormButton
					>
						<Grid container spacing={2}>
							<Grid item xs={12} md={4}>
								<MatesTextField
									name="city"
									label="Città"
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								<MatesTextField
									name="province"
									label="Provincia"
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								<MatesTextField
									name="region"
									label="Regione"
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								<MatesSelect
									name="position"
									label="Posizione"
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}>
									{Object.keys(PositionType).map((positionKey, index) =>
										<option value={positionKey} key={index}>
											<Trans id={`enums.asset-position.${positionKey}`}>
											</Trans>
										</option>
									)}
								</MatesSelect>
							</Grid>
							<Grid item xs={12} md={4}>
								<MatesSelect
									name="assetType"
									label="Tipo"
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}>
									{Object.keys(AssetType).map((type, index) =>
										<option value={type} key={index}>
											<Trans id={`enums.asset-types.${type}`}>

											</Trans>
										</option>
									)}
								</MatesSelect>
							</Grid>
							<Grid item xs={12} md={4}>
								<MatesSelect
									name="contractType"
									label="Tipo di contratto"
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}>
									{Object.keys(ContractType).map((typeKey, index) =>
										<option value={typeKey} key={index}>
											<Trans id={`enums.contract-type.${typeKey}`}>

											</Trans>
										</option>
									)}
								</MatesSelect>
							</Grid>
							<Grid item xs={12} md={3}>
								<MatesTextField
									name="glaMin"
									label="Dimensione minima"
									variant="outlined"
									control={this.props.control}
									trigger={this.props.trigger}
									formState={this.props.formState} />
							</Grid>
							<Grid item xs={12} md={3}>
								<MatesTextField
									name="glaMax"
									label="Dimensione massima"
									variant="outlined"
									control={this.props.control}
									trigger={this.props.trigger}
									formState={this.props.formState} />
							</Grid>
							<Grid item xs={12} md={3}>
								<MatesTextField
									name="minPrice"
									label="Prezzo minimo"
									variant="outlined"
									control={this.props.control}
									trigger={this.props.trigger}
									formState={this.props.formState} />
							</Grid>
							<Grid item xs={12} md={3}>
								<MatesTextField
									name="maxPrice"
									label="Prezzo massimo"
									variant="outlined"
									control={this.props.control}
									trigger={this.props.trigger}
									formState={this.props.formState} />
							</Grid>
							<Grid item xs={12} md={3}>
								<MatesTextField
									name="shopWindows"
									label="Numero di vetrine"
									variant="outlined"
									control={this.props.control}
									trigger={this.props.trigger}
									formState={this.props.formState} />
							</Grid>
							<Grid item xs={12} md={3}>
								<MatesSelect
									name="divisible"
									label={t({ id: "asset-search.divisible", message: "Divisibile" })}
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}>
									{
										Object.keys(SwitchEnum).map((typeKey, index) =>
											<option value={typeKey} key={index}>
												<Trans id={`enums.switch-enum.${typeKey}`}>

												</Trans>
											</option>
										)
									}
								</MatesSelect>
							</Grid>
							<Grid item xs={12} md={3}>
								<MatesSelect
									name="parkingSlots"
									label={t({ id: "asset-search.parking", message: "Parcheggi" })}
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}>
									{
										Object.keys(SwitchEnum).map((typeKey, index) =>
											<option value={typeKey} key={index}>
												<Trans id={`enums.switch-enum.${typeKey}`}>
												</Trans>
											</option>
										)
									}
								</MatesSelect>
							</Grid>
							<Grid item xs={12} md={3}>
								<MatesSelect
									name="airConditioning"
									label={t({ id: "asset-search.air-conditioning", message: "Aria condizionata" })}
									variant="outlined"
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}>
									{
										Object.keys(SwitchEnum).map((typeKey, index) =>
											<option value={typeKey} key={index}>
												<Trans id={`enums.switch-enum.${typeKey}`}>

												</Trans>
											</option>
										)
									}
								</MatesSelect>
							</Grid>
						</Grid>
					</AdvancedSearchbar>
				}
			</Box>

		)
	}
}

export default withUseFormHook<AssetAdvancedSearchForm>(
	AssetAdvancedSearch,
	AssetAdvancedSearchValidation,
	new AssetAdvancedSearchForm()
)
